import { BBROKER_STOCK_CATALOG } from './bbrokerStockCatalog.js';

const ADDRESS = /^0x[a-f0-9]{40}$/i;
export const WBNB_ADDRESS = '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c';
const ZERO = '0x' + '0'.repeat(40);
const stableAddresses = new Set([
  '0x55d398326f99059ff775485246999027b3197955',
  '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
  '0x8d0d000ee44948fc98c9b98a4fa4921476f08b0d',
  '0xce24439f2d9c6a2289f741120fe202248b666666',
  '0xe9e7cea3dedca5984780bafc599bd69add087d56',
  '0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3',
  '0xc5f0f7b66764f6ec8c8dff7ba683102295e16409',
]);
const cryptoAddresses = new Set([
  '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
  '0x570a5d26f7765ecb712c0924e4de545b89fd43df',
  '0x2170ed0880ac9a755fd29b2688956bd959f933f8',
]);
const stockAddresses = new Set(BBROKER_STOCK_CATALOG.map(a => a.address.toLowerCase()));
['0xe614e2fc6c787035ff51f452e8e826bfd32d5283', '0xcdf2f3e0fa43c47a6662a91c9e4a7c5f69762699',
  '0x3f53de71c126bdabae20f9cd64848d317f6c3238', '0x6786c0d38dcd4994d1e8fed481f6439a11a14a8a']
  .forEach(a => stockAddresses.add(a));
const stockSymbols = new Set(BBROKER_STOCK_CATALOG.map(a => a.symbol.toUpperCase()));
['INTCB', 'MUB', 'GOOGLB', 'QQQB'].forEach(s => stockSymbols.add(s));
const stableSymbols = new Set(['USDT', 'USDC', 'USD1', 'U', 'BUSD', 'DAI', 'FDUSD', 'TUSD', 'USDD']);
const cryptoSymbols = new Set(['BTC', 'BTCB', 'BTCA', 'WBTC', 'ETH', 'WETH', 'SOL', 'WSOL']);

/** Contract identity wins over an unverified token symbol. */
export function quoteAssetKind(address, symbol = '') {
  const a = String(address || '').toLowerCase();
  if (ADDRESS.test(a)) {
    if (a === ZERO || a === WBNB_ADDRESS) return 'bnb';
    if (stableAddresses.has(a)) return 'stable';
    if (cryptoAddresses.has(a)) return 'crypto';
    if (stockAddresses.has(a)) return 'stock';
    return 'custom';
  }
  const s = String(symbol || '').trim().toUpperCase();
  if (s === 'BNB' || s === 'WBNB') return 'bnb';
  if (stableSymbols.has(s)) return 'stable';
  if (cryptoSymbols.has(s)) return 'crypto';
  if (stockSymbols.has(s)) return 'stock';
  return s ? 'custom' : 'unknown';
}

/** A USD conversion needs the requested asset on the base side of a BSC pair. */
export function selectQuoteAssetRates(pairs, addresses) {
  const requested = new Set(addresses.map(a => String(a).toLowerCase()));
  const best = {};
  for (const pair of Array.isArray(pairs) ? pairs : []) {
    const base = String(pair?.baseToken?.address || '').toLowerCase();
    const quote = String(pair?.quoteToken?.address || '').toLowerCase();
    const price = Number(pair?.priceUsd);
    const liquidity = Number(pair?.liquidity?.usd);
    if (pair?.chainId !== 'bsc' || !requested.has(base) || !ADDRESS.test(quote) || base === quote ||
      !['bnb', 'stable'].includes(quoteAssetKind(quote)) ||
      !Number.isFinite(price) || price <= 0 || !Number.isFinite(liquidity) || liquidity <= 0) continue;
    if (best[base] && best[base].liquidity >= liquidity) continue;
    best[base] = { price, liquidity, symbol: String(pair.baseToken.symbol || '').trim().slice(0, 40),
      pairAddress: String(pair.pairAddress || '') };
  }
  return best;
}
